<template>
  <div :id="id" :style="{height:height,width:width}" />
</template>

<script>
import * as echarts from 'echarts';
import chinaJson from '../chinaJson/china.json'
import resize from '../mixins/resize'
import position from '../chinaJson/position.json'

export default {
  name: "mapChart",
  mixins: [resize],

  props: {
    id: {
      type: String,
      default: 'map'
    },
    height: {
      type: String,
      default: '1060px'
    },
    width: {
      type: String,
      default: '1060px'
    },
    data: {
      type: Array,
      default () {
        return [];
      }
    },
  },
  data () {
    return {
      mapChart: null
    }
  },
  mounted () {
    // echarts.registerMap("china", { geoJSON: chinaJson });
    echarts.registerMap("china", chinaJson);
    this.initMapChart()

    // this.timer = setTimeout(() => {
    //   this.initMapChart()
    // }, 600)
    console.log('调用了')
  },
  beforeDestroy () {
    // 实例销毁前 清空实例
    this.mapChart = null;
    // 解绑屏幕监听事件
    // window.removeEventListener('resize', this.resize, false);
  },
  watch: {
    data: {
      handler (newVal, oldVal) {
        this.convertData(this.data)
        console.log(newVal, oldVal)
      },
      deep: true
    }
  },

  methods: {
    // resize () {
    //   this.mapChart.resize();
    // },
    convertData (data) {
      let geoCoordMap = position
      let res = []
      for (let i = 0; i < data.length; i++) {
        let geoCoord = geoCoordMap[data[i].name]
        if (geoCoord) {
          res.push({
            name: data[i].name,
            value: geoCoord.concat(data[i].value)
          })
        }
      }
      console.log('geoCoordMap', res)
      return res
    },
    initMapChart () {
      var thiz = this
      // window.addEventListener('resize', this.resize, false)
      this.chart = echarts.init(document.getElementById(this.id))
      this.chart.setOption({
        title: {
          text: '净水设备全国分布图',
          textStyle: {
            color: '#fff',
            fontSize: 20
          },
          left: '3%',
          bottom: '21%'
        },
        tooltip: {//提示框组件。
          trigger: 'item',
          // formatter: '{b} : {c}'
          formatter: params => {
            return params.value[2] + '<br/>' + params.name;
          },
          backgroundColor: "rgba(0,0,0,0.5)",
          borderColor: "rgba(0,0,0,0.5)",
          textStyle: {
            color: "#fff",
          },
        },
        visualMap: {//图例
          type: 'piecewise',
          x: '3%',
          y: '80%',
          itemWidth: 12,
          itemHeight: 12,
          seriesIndex: [0],//对应screis.data的下标
          pieces: [
            {
              min: 1000, color: '#F0612D'
            },
            {
              min: 501, max: 999, color: '#E4E22E'
            },
            {
              min: 251, max: 500, color: '#50FDF3'
            },
            {
              min: 0, max: 250, label: ' 0 - 250', color: '#60F841'
            },
          ],
          inverse: true,
          inRange: {
            // symbol: 'circle',
            color: '#061C68'
          },
          controller: {
            inRange: {
              // symbolSize: [30, 100],
              color: '#061C68'
            }
          },
          textStyle: {
            color: '#fff'
          },
        },
        geo: {
          map: 'china',
          show: true,
          type: 'scatter',
          roam: true,//是否开启鼠标缩放和平移漫游,
          //  地图文本标签设置
          // label: {
          //   show: true,
          //   color: '#fff',
          // },
          // 鼠标划过区域
          zoom: 1.1,
          emphasis: {
            label: { show: false },
            itemStyle: {
              areaColor: "#061C68",
            },
          },
          // 地图区域设置
          itemStyle: {
            areaColor: "rgba(6, 28, 104, .8)",
            borderWidth: 2,
            borderColor: '#24C1F7',
          },
        },
        series: [
          {
            name: '中国',
            type: 'effectScatter', //带有涟漪特效动画的散点（气泡）图。
            coordinateSystem: 'geo',
            aspectScale: 1,
            symbol: 'circle',
            symbolSize: 8,
            showEffectOn: 'render',
            // 散点样式
            rippleEffect: {
              period: 4, // 动画速度，值越小，动画越快
              brushType: 'stroke' // 波纹的绘制方式
            },
            data: this.convertData(this.data),
            // 涟漪文字效果
            label: {
              normal: {
                show: true,
                // 提示内容
                formatter: params => {
                  return params.value[2] + '\n' + params.name;
                },
                position: [15, -5], // 提示方向
                color: '#fff'
              },
              emphasis: {
                show: true // 点
              }
            },
          }
        ]
      });
    }
  }
}
</script>

<style scoped>
</style>
